<div
    class="ap-illustration-container"
    [apInlineSVG]="getAssetUrl()"
    [setSVGAttributes]="size()"
    (svgInserted)="onSvgInserted($event)"
    [style.height]="height()"
    [style.width]="width()"
></div>
